<template>
  <BreadCrumb PageTitle="Détails de la composition" />
  <ViewComposition />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewComposition from "@/components/Composition/ViewComposition.vue";

  export default defineComponent({
    name: "ViewCompositionPage",
    components: {
      BreadCrumb,
      ViewComposition,
    },
  });
</script>